import { useEffect } from 'react'
function ProgressLine(props) {
    useEffect(() => {
    }, [])
    return (
        //<div id="divProgressLine" className="progressLine"></div>
        <hr id="divProgressLine" className="progressLine"></hr>
    )
}

export default ProgressLine
